import { Pipe, PipeTransform } from '@angular/core';
import { toLower } from 'lodash';

@Pipe({
  name: 'qtytype',
})
export class QtyTypePipe implements PipeTransform {
  transform(value :string) :any {
    switch (value.toLowerCase()) {
      case 'qty_onhand':
        return 'On-Hand';
      case 'qty_pending':
        return 'Pending';
      case 'qty_incoming':
        return 'Incoming';
      case 'qty_committed':
        return 'Committed';
      default:
        return value.toLowerCase();
    }
  }
}
